import React, { FC, memo } from 'react';
import { Divider } from 'udesk-ui';
import AutoAddComponentMixed from 'Component/pages/components/auto-add-component-mixed';
import UdeskLocales from 'UdeskLocales';

interface TemplateProps {
    textProps: Record<string, any>;
    voiceProps: Record<string, any>;
    ticketProps: Record<string, any>;
    videoProps: Record<string, any>;
    surveyProps: Record<string, any>;
}

const Template: FC<TemplateProps> = memo((props) => {
    const { textProps, voiceProps, ticketProps, videoProps, surveyProps } = props || {};

    return (
        <>
            <AutoAddComponentMixed
                title={
                    /* 自动添加文本数据 */ UdeskLocales['current'].pages.tasks.manage.template
                        .automaticAdd.autoAdd.index.automaticallyAddTextData
                }
                {...textProps}
            />

            <Divider />

            <AutoAddComponentMixed
                title={
                    /* 自动添加语音数据 */ UdeskLocales['current'].pages.tasks.manage.template
                        .automaticAdd.autoAdd.index.addVoiceDataAutomatically
                }
                {...voiceProps}
            />

            <Divider />

            <AutoAddComponentMixed
                title={
                    /* 自动添加工单数据 */ UdeskLocales['current'].pages.tasks.manage.template
                        .automaticAdd.autoAdd.index.automaticallyAddWorkOrderData
                }
                {...ticketProps}
            />

            <Divider />

            <AutoAddComponentMixed
                title={
                    /* 自动添加视频数据 */ UdeskLocales['current'].pages.tasks.manage.template
                        .automaticAdd.autoAdd.index.addVideoDataAutomatically
                }
                {...videoProps}
            />

            <AutoAddComponentMixed title={/* 自动添加问卷数据 */UdeskLocales['current'].pages.tasks.manage.template.automaticAdd.autoAdd.index.addQuestionnaireDataAutomatically} {...surveyProps} />
        </>
    );
});

export default Template;
